import { AnimationEvent } from '@angular/animations';
import { Directive, input } from '@angular/core';

import {
    ErrorNotification,
    INotification,
    LadderNotification,
    MaxRewardNotification,
    NotificationType,
    OneSelectionAwayNotification,
} from '../../acca-boost/model';
import { AccaBoostNotificationSyncService } from '../../acca-boost/services/digital/acca-boost-notification-sync.service';

@Directive({
    standalone: true,
})
export class QuickBetAccaBoostBaseComponent {
    accaBoostNotification = input.required<INotification>();

    notificationTypeEnum = NotificationType;

    constructor(private accaBoostNotificationSyncService: AccaBoostNotificationSyncService) {}

    onAnimationDone(event: AnimationEvent, type?: NotificationType): void {
        if (event.fromState === 'void' && type) {
            this.accaBoostNotificationSyncService.markAsDone(type);
        }
    }

    isNotificationType(notification: INotification, type: 'Error'): notification is ErrorNotification;
    isNotificationType(notification: INotification, type: 'Ladder'): notification is LadderNotification;
    isNotificationType(notification: INotification, type: 'MaxReward'): notification is MaxRewardNotification;
    isNotificationType(notification: INotification, type: 'OneSelectionAway'): notification is OneSelectionAwayNotification;
    isNotificationType(notification: INotification, type: keyof typeof NotificationType): boolean {
        return notification.type === type;
    }
}
